import InputType from "@/model/types/resource/InputType";
import VarType from "@/model/types/resource/VarType";

export default {


    downloadTxt(content,filename){
        const a = document.createElement('a');
        a.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(content);
        a.download = filename;
        a.click();

    },

    prepareHTML(content = '', limit = 500) {
        if (content !== '') {

            // Corrigir todos os <strong> e </strong> por <b> e </b>
            content = content.replace(/<strong>/gi, "<b>");
            content = content.replace(/<\/strong>/gi, "</b>");

            // Limitar para até 500 caracteres (ou outro valor passado)
            if (content.length > limit)
                content = content.substring(0, limit);
        }

        return content;
    },

    removeAccentuation(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },



    teste(state, error) {

        const b = new Blob([error.response.data], {type: "application/json"}),
            fr = new FileReader();

        fr.onload = e => {

            const objectError = JSON.parse(e.target.result)

            if (error.response.status === 500) {
                this.msgError(state, objectError.general[0])
            } else if (error.response.status === 610) {

                this.status = "subject"
                this.dialogRoutineShow = true
                this.dialogRoutineTotalRows = objectError.totalRows
                this.dialogRoutineTotalParts = objectError.totalParts
                this.openModal('modal-report-dialog-routine-by-part')

            }


        }

        fr.readAsText(b);

    },


    getAlternativeNativeValue(inputName) {

        const alternativeArray = document.getElementsByName(inputName);
        const alternativeChecked = Array.from(alternativeArray).find(radio => radio.checked);
        let alternativeChosen = 0

        if (alternativeChecked !== null && alternativeChecked !== undefined) {
            alternativeChosen = parseInt(alternativeChecked.value)
        }

        return alternativeChosen

    },


    /**position inicia com 1 até 5*/
    getParamFieldByPosition(form, position) {

        const fieldName = form['field' + position + 'Name']
        const fieldType = form['field' + position + 'Type']
        const fieldVar = form['field' + position + 'Var']
        const fieldMask = form['field' + position + 'Mask']
        const fieldLength = form['field' + position + 'Length']
        const fieldMinAccepted = form['field' + position + 'MinAccepted']
        const fieldMaxAccepted = form['field' + position + 'MaxAccepted']
        const fieldRequired = form['field' + position + 'Required']

        let field = {
            var: fieldVar, type: fieldType, name: fieldName, options: [], cols: 12
        }

        //Tipos Double por padrão terão 4 casas decimais para serem utilizadas nos parâmetros
        if (fieldVar === 3) {
            field.decimalPrecision = 4
        }

        if (fieldMask !== undefined && fieldMask !== null)
            field.mask = fieldMask

        if (fieldLength !== undefined && fieldLength !== null)
            field.length = fieldLength

        if (fieldMinAccepted !== undefined && fieldMinAccepted !== null)
            field.minAccepted = fieldMinAccepted

        if (fieldMaxAccepted !== undefined && fieldMaxAccepted !== null)
            field.maxAccepted = fieldMaxAccepted

        if (fieldRequired !== undefined && fieldRequired !== null)
            field.required = fieldRequired


        if (InputType.isList(fieldType)) {

            let options = form['field' + position + 'Options']

            if (options !== null && options !== undefined) {

                options = options.split(";")

                let fieldOptions = []


                for (const o of options) {

                    const option = o.split(":")

                    let optionValue
                    const optionText = option[1]

                    if (fieldType === VarType.type.INTEGER) {
                        optionValue = parseInt(option[0])
                    } else {
                        optionValue = "" + option[0]
                    }

                    fieldOptions.push({
                        value: optionValue,
                        text: optionText
                    })


                }

                field.options = fieldOptions

            }

        }

        return field

    },

    highlightSearch(text, search) {
        const searchTxt = "" + search

        if (text !== null && text !== undefined) {
            return text.replace(new RegExp(searchTxt, "ig"), "<span class='highlightSearched'>" + searchTxt.toUpperCase() + "</span>");
        } else {
            return ''
        }

    },

    goLink(url) {
        location = url
    },

    focusById(id) {
        if (document.getElementById(id) !== null)
            document.getElementById(id).focus()
    },

    reload() {
        location.reload()
    },

    lpad(value, length) {
        /*Permitido informar 0 para formatar por exemplo 0000*/
        if (value !== '' && value !== null) {
            return value.toString().padStart(length, "0")
        }
    },

    generateRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    },


    getPosition() {

        if (navigator.geolocation) {

            return new Promise((resolve, reject) =>
                navigator.geolocation.getCurrentPosition(location => {
                    resolve({
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude
                    })
                }, reject)
            )
        } else {
            return Promise.reject()
        }

    },


    getDevice() {

        if (navigator !== null && navigator.appName !== null && navigator.appName !== undefined) {
            return new Promise(resolve => {
                resolve({
                    appCodeName: navigator.appCodeName,
                    appName: navigator.appName,
                    platform: navigator.platform,
                    userAgent: navigator.userAgent
                })
            })
        } else {
            return Promise.reject()
        }

    },

    async goPath(state, path, addQuery, openNewTab = false) {

        let pathSend = path
        let query = {}
        let redirectQuery = null

        if (pathSend.substring(0, 1) !== '/') {
            //Coloca a barra no início
            pathSend = "/" + pathSend
        }

        if (pathSend.substring(pathSend.length - 1) === '/') {
            //Retira a barra final
            pathSend = pathSend.substring(0, pathSend.length - 1)
        }

        //ATENÇÃO SE O PATH SEND NÃO BATER EXATAMENTE IGUAL AO PATH DO ROUTER DARÁ PROBLEMA
        const lastPagePath = state.$store.getters.getLastPage.path

        if (pathSend === lastPagePath) {
            //Retorna com a listagem filtrada
            redirectQuery = state.$store.getters.getLastPage.query
        }

        if (addQuery !== null && redirectQuery !== null) {
            query = Object.assign({}, addQuery, redirectQuery);
        } else if (addQuery !== null) {
            query = addQuery
        } else if (redirectQuery !== null) {
            query = redirectQuery
        }
        if(openNewTab){
            const url = state.$router.resolve({ path: pathSend, query }).href
            window.open(url, '_blank')
        }else{
            await state.$router.push({path: pathSend, query})
        }


    },

    reportRender(r) {

        let error = false
        let charts = {}

        if (r.search(/<script>/i) > -1) {

            charts = r.substring(r.search(/<script>/i), r.search(/<\/script>/i))

            r = r.replace(charts, '')
            r = r.replace("</script>", "")

            charts = charts.replace(/<script>/i, '')
            charts = charts.replace('const charts = ', '')
            charts = charts.replaceAll('\n', '')

            charts = JSON.parse(charts)

            //Correção de funções enviadas
            for (let chart of charts) {

                //Conversão de funções String em functions nativas
                if (chart.tooltip && chart.tooltip.y && chart.tooltip.y.formatter) {
                    chart.tooltip.y.formatter = eval(chart.tooltip.y.formatter)
                }


            }

            if (charts === '') {
                error = true
                console.log("ERRO ORIGEM RELATORIO JSON")
            }


        }


        return {
            error,
            report: r,
            charts,
        }


    },

    async loadImageAsBlob(url) {
        const resp = await fetch(url, { method: 'GET' });

        if (!resp.ok) {
            throw new Error(`Falha ao baixar imagem (${resp.status}): ${url}`);
        }

        const blob = await resp.blob();
        return URL.createObjectURL(blob);
    },


    tagScript(src) {
        return "<script src=" + src + "></script>"
    },


    dateDiff(startDate, finishDate) {

        const normalize = (d) => {
            if (d instanceof Date) {
                return new Date(d.getFullYear(), d.getMonth(), d.getDate())
            }

            // string no formato YYYY-MM-DD
            const [y, m, day] = d.split('-')
            return new Date(Number(y), Number(m) - 1, Number(day))
        }

        const s = normalize(startDate)
        const f = normalize(finishDate)

        return Math.round((f - s) / (1000 * 60 * 60 * 24))
    },

    //https://bootstrap-vue.org/docs/components/toast
    toast(state, title = "Informação", message, variant = "info", toaster = "b-toaster-bottom-right", append = false, seconds = 3) {

        const h = state.$createElement
        const messageHTML = h('div', {domProps: {innerHTML: message}})

        state.$bvToast.toast(messageHTML, {
            title: title,
            toaster: toaster,
            variant: variant,
            solid: true,
            autoHideDelay: seconds * 1000,
            appendToast: append
        })
    },

    convertNumber(number, decimal, language, forceDecimals = false) {

        if (number !== null && number !== 0 && number) {

            let decimalUtilized = decimal;
            let forceDecimalsUtilized = forceDecimals;

            if (decimal > 0) {

                const roundNumber = number - Math.floor(number);
                const decimalNumber = parseFloat(roundNumber.toFixed(decimal));

                if (decimalNumber > 0) {
                    let decimalsLength = "" + decimalNumber
                    decimalsLength = decimalsLength.split(".")[1].length
                    decimalUtilized = decimalsLength
                    forceDecimalsUtilized = true
                }

            }

            if (forceDecimalsUtilized) {
                //Exibe os decimais, mesmo que não tenha utilizado
                return number.toLocaleString(language, {minimumFractionDigits: decimalUtilized});

            } else {
                //Exibe os decimais somente-se forem utilizados
                return number.toLocaleString(language);
            }


            //new Intl.NumberFormat(language, { maximumSignificantDigits: decimal }).format(number);

        } else {
            return 0
        }

    },

    convertDateBR(dateString, time = false) {

        if (dateString !== null && dateString !== "" && dateString) {

            let date

            if (dateString instanceof Date) {
                date = dateString
            } else {
                if (dateString.indexOf("T") < 0) {
                    dateString += 'T00:00:00'
                }
                date = new Date(dateString)
            }

            if (time) {
                return date.toLocaleString('pt-br', {timeZone: "America/Sao_Paulo"}).toString().replace(/,/, '')
            } else {
                return date.toLocaleString('pt-br', {timeZone: "America/Sao_Paulo"}).toString().split(" ")[0].replace(/,/, '')
            }

        }

    },

    msgConfirm(state, title = "Tem certeza?", msgConfirm, callback, okTitle = "Continuar mesmo assim") {

        let title_
        const ele = state.$createElement('div', {domProps: {innerHTML: msgConfirm}})

        if (title !== '') {
            title_ = title
        } else {
            title_ = 'Confirmação'
        }

        state.$bvModal.msgBoxConfirm(ele, {
            title: title_,
            okVariant: "primary",
            okTitle: okTitle,
            cancelTitle: 'Cancelar',
            hideHeaderClose: false,
        }).then(value => {

            if (value) {
                callback()
            }

        })

    },


    msgConfirmDelete(state, callback, msg = '') {

        let msg_confirm_delete = state.t('msg-confirm-delete')

        if (msg !== '') {
            msg_confirm_delete = msg
        }

        const ele = state.$createElement('div', {domProps: {innerHTML: msg_confirm_delete}})

        state.$bvModal.msgBoxConfirm(ele, {
            title: state.t('confirm'),
            okVariant: 'danger',
            okTitle: state.t('delete'),
            cancelTitle: state.t('no'),
            hideHeaderClose: false,
        }).then(value => {

            if (value) {
                callback()
            }

        })

    },

    open(url){
        window.open(url, '_blank')
    },
    msg(state, title, message, callback = null, size = '') {

        const h = state.$createElement
        const messageHTML = h('div', {domProps: {innerHTML: message}})

        state.$bvModal.msgBoxOk(messageHTML, {
            title: title,
            okVariant: 'info',
            size: size !== '' ? size : 'md',
            okTitle: 'Ok',
            hideHeaderClose: false,
        }).then(value => {

            if (value && callback) {
                callback()
            }

        })

    },

    getAccountName() {

        if (localStorage.getItem('account')) {
            const account = JSON.parse(localStorage.getItem('account'))

            if (account && account.accountName) {
                return account.accountName
            } else {
                return ''
            }

        }

    },

    getAccountPrefix() {

        if (localStorage.getItem('account')) {
            const account = JSON.parse(localStorage.getItem('account'))

            if (account && account.accountPrefix) {
                return account.accountPrefix
            } else {
                return ''
            }

        }

    },

    getAccountModule() {

        if (localStorage.getItem('account')) {
            const account = JSON.parse(localStorage.getItem('account'))

            if (account && account.module) {
                return account.module
            } else {
                return ''
            }

        }

    },

    getAccountHelpDocURL() {

        if (localStorage.getItem('account')) {
            const account = JSON.parse(localStorage.getItem('account'))

            if (account && account.helpDocUrl) {
                return account.helpDocUrl
            } else {
                return ''
            }

        }

    },

    getNameUser() {

        if (localStorage.getItem('account')) {
            const account = JSON.parse(localStorage.getItem('account'))

            if (account && account.name) {
                return account.name
            }

        }

    },

    getEmailUser() {

        const filter = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

        if (localStorage.getItem('account')) {
            const account = JSON.parse(localStorage.getItem('account'))

            if (account && account.login) {

                //Retorna somente se for um e-mail válido (para casos onde o login é por código de acesso, retornará em branco
                if (filter.test(account.login)) {
                    return account.login
                }

            }

        }

    },

    getTemplateLogo(size = "small") {

        //Demais tamanhos não estão sendo armazenados, checar antes de usar

        if (localStorage.getItem('template') && localStorage.getItem('template') !== "undefined") {

            const template = JSON.parse(localStorage.getItem('template'))

            if (size === "small" && template.logoSmall && template.logoSmall !== "") {
                return template.logoSmall
            }
        }

    },

    setFavicon(icon) {

        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }

        link.href = link.href.replace('favicon', icon)
    },

    async generalResponseError(state, error, callback = null) {



        if (error.response) {

            if (error.response.status === 500) {

                if (error.response.data instanceof Blob) {

                    const b = new Blob([error.response.data], {type: "application/json"}),
                        fr = new FileReader();

                    fr.onload = e => {

                        const objectError = JSON.parse(e.target.result)

                        if (error.response.status === 500) {
                            this.msgError(state, objectError.general, callback)
                        }

                    }

                    fr.readAsText(b);

                } else {
                    this.msgError(state, error.response.data.general, callback)
                }

            }

        }

    },

    msgErrorForm(state, errors, callback = null) {

        /*console.log(errors)
        Versão avançada com os detalhes
       for(const error in this.$refs.validation.errors){

         __ob__

         if(!error.includes("__ob__") && )
         console.log(error)
       }
        */

        this.msgError(state, "Por favor verifique todos os campos destacados com erro antes de continuar.", callback)
    },

    msgError(state, message, callback = null, title = '') {

        const h = state.$createElement

        let messageHTML

        if (Array.isArray(message)) {

            const arrayMessage = []

            for (const item of message) {
                arrayMessage.push(h('div', {
                    domProps: {
                        innerHTML: item,
                        style: 'padding:5px; border-bottom:solid 1px #e1e1e1'
                    }
                }))
            }

            messageHTML = arrayMessage

        } else {

            messageHTML = h('div', {domProps: {innerHTML: message}})

        }


        let title_ = state.t('error')

        if (title !== '' && title !== null)
            title_ = title

        state.$bvModal.msgBoxOk(messageHTML, {
            title: title_,
            okVariant: 'danger',
            okTitle: 'Ok',
            hideHeaderClose: false,
        }).then(value => {

            if (value && callback) {
                callback()
            }

        })

    },

    randomIntFromInterval(min, max) { // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min)
    },


    formatZeroNumber(valor = "", qtyZeros) {

        return String(valor).padStart(qtyZeros, '0');

    },

    currentYear() {
        return this.currentDate().split('-')[0]
    },

    currentDate() {

        const date = new Date()
        //const offset = date.getTimezoneOffset() 180 é padrão para o Brasil, fazendo isso será setado com a data curta mais correta, pois dependendendo da horá será enviado como no dia seguinte.
        const dateNow = new Date(date.getTime() - (180 * 60 * 1000))
        return dateNow.toISOString().split('T')[0]

    },

    currentDateTime() {
        return this.convertDateBR(new Date(), true)
    },

    currentHour() {
        const date = new Date()
        //const offset = date.getTimezoneOffset() 180 é padrão para o Brasil, fazendo isso será setado com a data curta mais correta, pois dependendendo da horá será enviado como no dia seguinte.
        const dateNow = new Date(date.getTime() - (180 * 60 * 1000))
        const time = dateNow.toISOString().split('T')[1].split(':')[0] + ':00'
        return time


    }
    ,

    defaultTemplate() {

        const head = document.getElementsByTagName('head')[0]

        if (head.children) {

            for (const item of head.children) {

                if (item.accessKey === "customTemplate") {
                    item.remove()
                }

            }
        }

    },
    customTemplate() {

        if (localStorage.getItem('template') && localStorage.getItem('template') !== "undefined") {

            const template = JSON.parse(localStorage.getItem('template'))
            let style = document.createElement('style')
            let styleRulers = ""

            /** PERSONALIZAÇÃO POR CLIENTE */

            if (template.colorPrimary && template.colorPrimary !== "") {
                styleRulers +=
                    ":root {" +
                    "--template-color-primary: " + template.colorPrimary + "; " +
                    "--template-color-secondary: " + template.colorSecondary + "; " +
                    "--template-color-light: " + template.colorLight + "; " +
                    "}";
            }

            if (template.logoSmall && template.logoSmall !== "") {
                styleRulers += ".app-logo { background-image: url(" + template.logoSmall + ") !important; } " +
                    ".logo-src { background-image: url(" + template.logoSmall + ") !important; } "
            }

            style.accessKey = "customTemplate"
            style.innerHTML = styleRulers
            document.getElementsByTagName('head')[0].appendChild(style);


        }

    }
    ,

    /** Corrige o nome do arquivo removendo informações não válidas*/
    nameFile(name, ext) {
        if (name !== null && name !== '') {


            let nameValid = name.toLowerCase().replace(/[/\\?%*:|"<>]/g, '')
            nameValid = nameValid.replaceAll("  ", " ")
            nameValid = nameValid.replaceAll(" ", "-")
            nameValid = nameValid.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            return nameValid + "." + ext
        } else {
            return ""
        }
    }
    ,

    logout(state) {

        localStorage.removeItem('account')
        state.$store.commit("setAccount", null)

        setTimeout(() => {
            state.$router.push({name: 'login'})
        }, 100)


    }
    ,


}